import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor() { }

  getCurrentlyLoggedInCompanyId() : number {
    return 1;
  }
}
